































/* eslint-disable vue/prop-name-casing */
import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { getCategoryCarouselLink } from '@shared/helpers/category/getCategory';
import { sanitizeLinkUrl } from '@shared/helpers/sanitizeLinkUrl';
import { ILink, IStoryblokShopifyCategory } from '@shared/types/storyblok';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

import CardSection from '~/components/CardSection/CardSection.vue';
import CategoryCard from '~/components/CategoryCard/CategoryCard.vue';
import Container from '~/components/Container.vue';

export default defineComponent({
  name: 'CategoryCarousel',
  components: {
    CardSection,
    CategoryCard,
    Container,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: Object as PropType<ILink>,
      default: () => ({}),
    },
    link_text: {
      type: String,
      default: '',
    },
    categories: {
      type: Array as PropType<IStoryblokShopifyCategory[]>,
      default: () => [],
    },
  },
  setup(props) {
    const linkUrl = computed(() =>
      sanitizeLinkUrl(`${props.link.cached_url || props.link.url || ''}`),
    );

    return {
      getCategoryCarouselLink,
      linkUrl,
      getStoryblokImageURL,
    };
  },
});
